import { Grid, GridColumn, GridSortChangeEvent } from '@progress/kendo-react-grid'
import * as React from 'react'
import { connect } from 'react-redux'
import * as ReactStrap from 'reactstrap'
import * as Redux from 'redux'
import * as App from '../../app/types'
import { FlashMessage } from '../../components/flash-message'
import { Loading } from '../../components/loading'
import * as RasaModal from '../../components/modal'
import * as RasaInput from '../../components/rasa-input'
import * as Sortable from '../../components/sortable'
import * as Sources from '../sources/render'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Render from './render'
import './styles.css'
import * as Types from './types'
import * as Utils from './utils'

interface AppProps {
  app: App.State,
}

interface SubmitAddTagsProps {
  submitModal: RasaModal.SubmitWithId<Types.ModalData>
}

type AddTagsModalProps =
  Types.ComponentState &
  RasaModal.ComponentState<Types.ModalData> &
  RasaModal.DispatchState &
  SubmitAddTagsProps &
  AppProps

const AddTagsModalComponent = ({app, filter, modal, submitModal, showModal, updateModal}: AddTagsModalProps) =>
<ReactStrap.Modal className="modal-lg" isOpen={modal.isOpen} toggle={showModal}>
  <form className="k-form">
    <ReactStrap.ModalHeader toggle={showModal}>Enter tags</ReactStrap.ModalHeader>
    <ReactStrap.ModalBody>
      <FlashMessage />
      <RasaInput.RasaInput label="Tags"
                           placeholder=""
                           value={modal.data.tags}
                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                             updateModal({name: 'tags', value: e.target.value})} />
    </ReactStrap.ModalBody>
    <ReactStrap.ModalFooter>
      {modal.isSubmitting ? <Loading size={Loading.Sizes.SMALL} /> : <span/>}
      <ReactStrap.Button color="primary"
              disabled={modal.isSubmitting || !Utils.modalStateValid(modal.data)}
              onClick={() => submitModal(filter ? filter.id : -1, app.selectedCommunity, modal.data)}>
        Save
      </ReactStrap.Button>
      <ReactStrap.Button onClick={showModal}>Cancel</ReactStrap.Button>
    </ReactStrap.ModalFooter>
  </form>
</ReactStrap.Modal>

export const AddTagsModal = connect(
  ({app}: AppProps) => ({app}),
  {
    showModal: Actions.toggleModal,
    submitModal: Actions.createTags,
    updateModal: Actions.updateModalField,
  },
)(AddTagsModalComponent)

interface SubmitAddFilterProps {
  submitModal: RasaModal.Submit<Types.ModalData>
}

type AddFilterModalProps =
  RasaModal.ComponentState<Types.ModalData> &
  RasaModal.DispatchState &
  SubmitAddFilterProps &
  AppProps

const CreateFilterModalComponent = ({app, modal, submitModal, showModal, updateModal}: AddFilterModalProps) =>
<ReactStrap.Modal className="modal-lg" isOpen={modal.isOpen} toggle={showModal}>
  <form className="k-form">
    <ReactStrap.ModalHeader toggle={showModal}>Create Filter Group</ReactStrap.ModalHeader>
    <ReactStrap.ModalBody>
      <RasaInput.RasaInput label="Name"
                            placeholder=""
                            value={modal.data.name}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                              updateModal({name: 'name', value: e.target.value})} />
      <RasaInput.RasaInput label="Tags"
                           placeholder=""
                           value={modal.data.tags}
                           onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                             updateModal({name: 'tags', value: e.target.value})} />
    </ReactStrap.ModalBody>
    <ReactStrap.ModalFooter>
      {modal.isSubmitting ? <Loading size={Loading.Sizes.SMALL} /> : <span/>}
      <ReactStrap.Button color="primary"
              disabled={modal.isSubmitting || !Utils.modalAddStateValid(modal.data)}
              onClick={() => submitModal(app.selectedCommunity, modal.data)}>
        Save
      </ReactStrap.Button>
      <ReactStrap.Button onClick={showModal}>Cancel</ReactStrap.Button>
    </ReactStrap.ModalFooter>
  </form>
</ReactStrap.Modal>

export const CreateFilterModal = connect(
  ({app}: AppProps) => ({app}),
  {
    showModal: Actions.toggleModal,
    updateModal: Actions.updateModalField,
  },
)(CreateFilterModalComponent)

export const UncontrolledCreateFilterModal = connect(
  ({app}: AppProps) => ({app}),
)(CreateFilterModalComponent)

interface HeaderProps {
  filterGroup: Types.ComponentState,
  showModal: RasaModal.Toggle,
}

const Header = ({filterGroup, showModal, view}: HeaderProps & Types.WrappedViewState) =>
<div>
  <FlashMessage />
  <ReactStrap.Row className="margin-auto">
    <ReactStrap.Col sm="12" md="10" className="text-left page-header--padding">
      <div className="page-header">
        <span className="title">Filter Group {filterGroup.filter && filterGroup.filter.name}</span>
        <ReactStrap.Button
          disabled={view.isLoading}
          className="secondary-button"
          onClick={showModal}
          title="Add Tag">
          Add Tag
        </ReactStrap.Button>
      </div>
    </ReactStrap.Col>
  </ReactStrap.Row>
</div>

const HeaderConnect = connect(
  null,
  ({
    showModal: Actions.toggleModal,
  }),
)(Header)

interface DispatchProps {
  dispatch: Redux.Dispatch<Redux.Action>
}
type Props = Types.WrappedState & DispatchProps

const Component = ({filterGroup, dispatch}: Props) =>
<div>
{filterGroup.view.isLoading
?
  <Loading center size={Loading.Sizes.LARGE} />
:
<div>
  <ReactStrap.Row>
    <ReactStrap.Col>
      <HeaderConnect view={filterGroup.view} filterGroup={filterGroup.data}/>
    </ReactStrap.Col>
  </ReactStrap.Row>
  <ReactStrap.Row>
   <ReactStrap.Col sm={12} md={4}>
     <div>Tags</div>
     <Grid data={filterGroup.data.filter.tags}
           sortable={{
             allowUnsort: true,
             mode: 'multiple',
           }}
           sort={filterGroup.view.sort}
           onSortChange={(e: GridSortChangeEvent) => dispatch({
                               options: { value: e.sort },
                               type: Sortable.sortTableConstant(Constants.FETCH_FILTER_GROUP),
           })}>
       <GridColumn field="tag" title="Tag"/>
       <GridColumn cell={Render.ActiveCell} field="is_active" title=" "/>
     </Grid>
   </ReactStrap.Col>
   <ReactStrap.Col sm={12} md={4}>
     <div>Used By</div>
     <Grid data={filterGroup.data.filter.sources}>
       <GridColumn cell={Sources.SourceCell} field="name" title="Name"/>
       <GridColumn field="filter_type"/>
       <GridColumn cell={Render.EditSourceCell}/>
     </Grid>
   </ReactStrap.Col>
 </ReactStrap.Row></div>}
  <AddTagsModal filter={filterGroup.data.filter} modal={filterGroup.modal}/>
</div>

export const FilterGroupComponent = connect(
  ({filterGroup}: Types.WrappedState) => ({filterGroup}),
  (dispatch: any) => ({dispatch}),
)(Component)



// WEBPACK FOOTER //
// ./src/pages/filter-group/component.tsx